import type { LogAttributeFilter } from '@/components/shared/log-filters/types'
import type { MetricsFilterInput } from '@/graphql.types'

export function filtersToQuery(
  filters: LogAttributeFilter[]
): MetricsFilterInput[] {
  return filters.map((filter) => {
    const isMultiValue =
      filter.operator === 'IS_IN' || filter.operator === 'IS_NOT_IN'

    if (isMultiValue) {
      return {
        key: filter.key,
        operator: filter.operator,
        values: (filter.value ?? '')
          .split(',')
          .map((v) => v.trim())
          .filter(Boolean),
      }
    }

    return {
      key: filter.key,
      operator: filter.operator,
      value: filter.value ?? '',
    }
  })
}
